export default __webpack_public_path__ + "maps-guides-markers-annotations-1200-4bdfc12125d4ceabf4d2f77e9034d500.webp";